
import type { ProductStatusCode } from '~/type/product/Product';
interface Props {
  code: ProductStatusCode;
  value: string;
  icon?: boolean;
  rightIcon?: boolean;
  link?: boolean;
  size?: 'small' | 'medium';
  title?: string;
}
const __sfc_main = {};
__sfc_main.props = {
  code: {
    key: "code",
    required: true,
    type: null
  },
  value: {
    key: "value",
    required: true,
    type: String
  },
  icon: {
    key: "icon",
    required: false,
    type: Boolean,
    default: true
  },
  rightIcon: {
    key: "rightIcon",
    required: false,
    type: Boolean,
    default: false
  },
  link: {
    key: "link",
    required: false,
    type: Boolean,
    default: false
  },
  size: {
    key: "size",
    required: false,
    type: String,
    default: 'medium'
  },
  title: {
    key: "title",
    required: false,
    type: String
  }
};
__sfc_main.setup = (__props, __ctx) => {
  function getClass(code: ProductStatusCode) {
    switch (code) {
      case 'FEW':
        return 'few';
      case 'IN_STOCK':
        return 'available';
      case 'PRE_ORDER':
        return 'onorder';
      case 'NOT_AVAILABLE':
        return 'unavailable';
    }
  }
  return {
    getClass
  };
};
export default __sfc_main;
